
<script>
export default {
    name: "Modal",

    emits: ['toggle'],

    props : ['closeIcon', 'btnText', 'btnIcon', 'btnClass', 'modalInnerClass', 'open'],

    data: function()
    {
        return {
            internalState: null,
        }
    },

    methods:
    {
        toggleModal() {
            if(this.open){
                this.$emit('toggle');
                return;
            }

            this.internalState = this.isInternalStateOpen() ? 'close' : 'open';
        },

        isInternalStateOpen() {
            return (this.internalState === 'open');
        }
    },

    computed:{
        activeClass() {
            if(this.open) {
                return this.open ? 'active' : '';
            }

            if(this.internalState) {
                return this.isInternalStateOpen() ? 'active' : '';
            }
        },
        hasFooterSlot() {
            return !!this.$slots.footer;
        }
    },

    created(){
        window.addEventListener("keydown", e => {
            if(event.keyCode === 27 && this.open){
               this.toggleModal();
           }
        });
    }
}

</script>

<template>
    <div>
        <button type="button" v-if="btnText" @click="toggleModal" :class="btnClass">
            <span v-html="btnIcon"></span>
            <span v-html="btnText"></span>
        </button>
        <div class="modal" :class="activeClass">
                <div class="modal__layer-bg modal__close" @click="toggleModal"></div>

            <div class="modal__inner" :class="modalInnerClass">
                <div class="modal__head">
                    <button @click="toggleModal" type="button" aria-label="Lukk" class="modal__close-btn">
                    <span class="d-none">Lukk</span>
                    <span v-html="closeIcon"></span>
                    </button>
                </div>

                <div class="modal__top">
                    <slot name="top"></slot>
                </div>

                <div class="modal__body">
                    <slot name="body"></slot>
                </div>

                <div class="modal__footer" v-if="hasFooterSlot">
                    <slot name="footer"></slot>
                </div>

            </div>
        </div>
    </div>
</template>